import { DaghfalApp } from '@daghfal/core';
import '@daghfal/core/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { strings } from './strings';

const container = document.getElementById('root');
if (!container) throw new Error('The #root element is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    <DaghfalApp appKey="admin-console" appearance="console" catalogue={strings}>
      <App />
    </DaghfalApp>
  </StrictMode>,
);
